<template>
  <el-date-picker
    v-model="value"
    type="month"
    placeholder="选择月"
    :disabled="disabled"
    :clearable="clearable"
    :picker-options="setMonthDisabled"
    @change="change"
    @focus="focus"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: 'MonthPicker',
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showMonths: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    setMonthDisabled() {
      return {
        disabledDate: (time) => {
          const month = new Date(time).Format('yyyy-MM');
          const index = this.showMonths.findIndex((v) => v === month);
          return index === -1;
          return false;
        },
      };
    },
  },
  data() {
    return {};
  },
  methods: {
    focus() {
      this.$emit('focus');
      // this.$nextTick(() => {
      //   const nodes =
      //     document.getElementsByClassName('el-month-table')[0].childNodes[0]
      //       .childNodes;
      //   const d1 = nodes[0].cells[0].childNodes[0].childNodes[0];
      //   d1.setAttribute('style', 'color: red');
      //   console.log(d1);
      // });
    },
    change(val) {
      this.$emit('input', val ? new Date(val).Format('yyyy-MM') : '');
    },
  },
};
</script>
<style lang="scss" scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
</style>
